import { Row, Text } from "@/components";

export const KanbanOwner = ({
  ownerUserIds,
  userInitialsMap,
}: {
  ownerUserIds: number[];
  userInitialsMap: Record<number | string, string>;
}) => {
  if (ownerUserIds.length === 0) return null;

  return (
    <Row className="items-center gap-1">
      {ownerUserIds.map((userId) => (
        <Row
          key={userId}
          className="h-5 w-5 items-center justify-center rounded-full bg-slate-200 opacity-90 ring-1 ring-slate-300/80"
        >
          <Text className="text-[8px] font-semibold uppercase text-slate-500">
            {userInitialsMap[userId] ?? "?"}
          </Text>
        </Row>
      ))}
    </Row>
  );
};
